import { Bookmark } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export const SaveClubButton = ({ slug, className = "", size = 16, label = false }) => {
  const { user, savedSlugs, toggleSave, signIn } = useAuth();
  const saved = savedSlugs.has(slug);

  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user) {
      toast("SIGN IN TO SAVE CLUBS", {
        description: "Keep a shortlist of the clubs you want to run with.",
        action: { label: "SIGN IN", onClick: signIn },
      });
      return;
    }
    toggleSave(slug);
  };

  return (
    <button
      type="button"
      data-testid={`save-club-${slug}`}
      onClick={onClick}
      title={saved ? "Remove from My Clubs" : "Save to My Clubs"}
      className={className}
    >
      <Bookmark size={size} fill={saved ? "currentColor" : "none"} />
      {label && <span className="font-mono-label">{saved ? "SAVED" : "SAVE CLUB"}</span>}
    </button>
  );
};
